import React from "react";
import { IconTitleDescriptionActionCard } from "@reusejs/react";

export default function SectionHeading(props: any) {
  return (
    <IconTitleDescriptionActionCard
      title={props.title}
      description={props.description}
      actions={props.actions ? props.actions : null}
      itemTitleDescriptionCardBaseClasses={{
        ...props.itemTitleDescriptionCardBaseClasses,
      }}
    />
  );
}
